import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import React from 'react'
import { Text } from 'react-native'

import { getPathWithParams } from '@/utils/url'
import PhosphorIcon from '@ui-kit/components/PhosphorIcon'
import { body2 } from '@ui-kit/core/typography'

export const FlowStepBackLink = ({
  flowName,
  previousStep,
  hidden,
  whitelistedParams,
  onBack,
}: {
  flowName: string
  previousStep?: string
  hidden: boolean
  whitelistedParams: string
  onBack: () => void
}) => {
  const { t } = useTranslation()
  if (!previousStep || hidden) {
    return null
  }
  return (
    <Link
      replace
      href={getPathWithParams(`/flows/${flowName}/${previousStep}`, { params: whitelistedParams })}
      data-testid="step_back_link"
      className="-mb-2.5 flex w-fit flex-row items-center gap-1.5 xl:hidden"
      onClick={onBack}
    >
      <PhosphorIcon name="CaretLeft" size={16} />
      <Text className={body2({ weight: 'semibold' })}>
        {t('sharedFlows_common:steps.footer.back')}
      </Text>
    </Link>
  )
}
